import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";

export const ConditionalBlockView = (props) => {
  const { node, deleteNode, editor, getPos } = props;
  const { logic } = node.attrs;

  // 🗑️ Delete the whole conditional block
  const handleDelete = () => {
    deleteNode();
  };

  // ✏️ Edit the conditional block
  const handleEdit = () => {
    const conditions = node.content.content
      .filter((n) => n.type.name === "condition")
      .map((n) => n.attrs);

    // ✅ Include position in callback
    const pos = typeof getPos === "function" ? getPos() : null;

    // fire callback for parent React component
    editor.options.onEditConditionalBlock?.({
      logic,
      conditions,
      pos,
    });
  };

  const uniqueKey = `${node.attrs.logic}-${JSON.stringify(
    node.content.content
      .filter((n) => n.type.name === "condition")
      .map((n) => n.attrs)
  )}`;

  return (
    <NodeViewWrapper as="conditional-block" key={uniqueKey}>
      {logic && <span className="conditional-block-logic">{logic}</span>}
      <div
        style={{
          position: "absolute",
          top: "4px",
          right: "-16px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <button
          onClick={handleEdit}
          className="btn btn-gray border size-8 p-0 d-flex justify-content-center align-items-center bg-white"
        >
          <i className="bx bx-pencil bx-xs"></i>
        </button>
        <button
          onClick={handleDelete}
          className="btn btn-gray border size-8 p-0 d-flex justify-content-center align-items-center text-red-500 bg-white"
        >
          <i className="bx bx-trash bx-xs"></i>
        </button>

        {/* <button
          className="btn btn-gray border size-8 p-0 d-flex justify-content-center align-items-center bg-white"
        >
          <i className='bx bx-git-merge bx-xs'></i>
        </button> */}
      </div>
      {/* Child content */}
      <NodeViewContent />
    </NodeViewWrapper>
  );
};
